/**
 * @file
 * Simple helpers for the ymca_lb_calgary theme.
 */

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  // YMCA LB menu search.
  Drupal.behaviors.ymcaMenuSearch = {
    attach: function (context, settings) {
      let $desk_search = $('.lb-search-form', context);
      let $desk_search_icon = $desk_search.find('.search-input-decoration');
      let $input = $desk_search.find('.search-input');
      let $submit = $desk_search.find('.search-submit');

      $desk_search_icon.on('click keypress', function (event) {
        let keycode = (event.keyCode ? event.keyCode : event.which);
        if (event.type === 'click' || keycode === '13') {
          let _this = $(this);
          if (_this.hasClass('expanded')) {
            if ($input.val() !== '') {
              $submit.click();
              return;
            }
          }

          _this.toggleClass('expanded');
          $desk_search.toggleClass('expanded');
        }
      });
    },
  };

})(jQuery, Drupal, drupalSettings, once);
